"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheV2Synchronized = void 0;
const informant_1 = require("./informant");
const listener_1 = require("./listener");
const shareableCache_1 = require("./shareableCache");
class CacheV2Synchronized {
    constructor(data) {
        this.cache = new shareableCache_1.ShareableCache(data.store);
        this.informant = new informant_1.EventBusSynchronizedCacheInformant(data.cacheName, data.eventBus);
        this.listener = new listener_1.EventBusSynchronizedCacheListener(data.cacheName, this.cache, data.eventBus);
        this.listener.initializeListeners();
    }
    setInitialData(data, cacheLiveTime) {
        return this.cache.setInitialData(data, cacheLiveTime);
    }
    getInitialData() {
        return this.cache.getInitialData();
    }
    cleanCache() {
        return this.informant.cleanCache();
    }
    removeCached(key) {
        return this.informant.removeCached(key);
    }
    setCached(key, result, cacheLiveTime) {
        return this.informant.setCached(key, result, cacheLiveTime);
    }
    getCached(key) {
        return this.cache.getCached(key);
    }
}
exports.CacheV2Synchronized = CacheV2Synchronized;
//# sourceMappingURL=cache.js.map